import { bufferToBase64 } from "../../../utils/array";

export const parseAudio = async (response) => {
  const base64 = bufferToBase64(response.data);
  return base64;
};
